<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app floating>
			<v-list dark>
				<v-list-item @click="drawer = !drawer">
					<v-list-item-action>
						<v-icon>{{ hamburger_icon }}</v-icon>
					</v-list-item-action>
				</v-list-item>
			</v-list>
      <v-img
        :src="require(`@/assets/pp-transparent.png`)"
        height="60"
        alt="pp-logo"
        contain
        style="cursor:pointer;"
        class="mb-8 mt-2"
        @click="backtoHome()"
      />
      <v-list dark>
        <v-list-item v-for="item in items" :key="item.to" :to="item.to">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app elevation="0">
      <v-btn v-if="!drawer" class="header-button" fab dark x-small @click="drawer = !drawer">
				<v-icon dark>{{ hamburger_icon }}</v-icon>
      </v-btn>

      <v-toolbar-title
        style="cursor:pointer;"
        class="ml-0 pl-4"
        @click="backtoHome()"
      >
      </v-toolbar-title>

      <v-spacer />

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="info" dark v-bind="attrs" v-on="on" small class="mr-4">
            DATA: PCP {{ currentVersion }} 
            <v-icon right dark>fas fa-caret-down</v-icon>
          </v-btn>
        </template>
        <v-list color="info" dense class="pa-0">
          <v-list-item dense @click="handleChangeVersion">
            <v-list-item-title class="white--text">
              DATA: PCP {{ showVersionOption }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn class="header-button" fab dark x-small @click="logout()">
        <v-icon dark>fas fa-sign-out-alt</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main :class="$vuetify.breakpoint.smAndUp ? 'mx-12' : ''">
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer color="white--text" app>
      <v-spacer></v-spacer>
      <div class="font-italic body-2">
        &copy; 2006- {{ new Date().getFullYear() }} Pacific Prime, All rights
        reserved Pacific Prime
      </div>
    </v-footer>
    <ModalError></ModalError>
  </v-app>
</template>

<script>
import ModalError from "@/components/default/ModalError";

export default {
  components: {
    ModalError,
  },
  data: () => ({
    dialog: false,
    drawer: true,
		hamburger_icon: "fas fa-bars",
    currentVersion: "v2",
    items: [
      { icon: "fas fa-th-list", text: "Dashboard", to: "/" },
      {
        icon: "fas fa-chart-line",
        text: "Statistics Report",
        to: "/v2/client_report",
      },
      { icon: "fas fa-chart-bar", text: "HR Activity", to: "/hr_activity" },
      { icon: "fas fa-history", text: "Access History", to: "/access_log" },
      {
        icon: "fas fa-file-download",
        text: "Resource Access",
        to: "/resource_log",
      },
    ],
    versions: [
      { name: "PCP V.1", value: "v1" },
      { name: "PCP V.2", value: "v2" },
    ],
  }),
  computed: {
    showVersionOption() {
      let text = "";
      if (this.currentVersion == "v1") {
        text = "V2";
      }
      if (this.currentVersion == "v2") {
        text = "V1";
      }
      return text;
    },
  },
  methods: {
    backtoHome() {
      this.$router.push("/");
    },
    logout() {
      this.$router.push("/logout");
    },
    handleChangeVersion() {
      // let selectedVersion = event.target.value;
      if (this.currentVersion == "v1") {
        this.currentVersion = "v2";
        this.items[1].to = "/v2/client_report";
      } else if (this.currentVersion == "v2") {
        this.currentVersion = "v1";
        this.items[1].to = "/v1/client_report";
      }
      this.$store.dispatch("Layout/SET_VERSION", this.currentVersion);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application {
  background-color: #f9fafb;
}
.v-app-bar {
  background-color: #f9fafb;
  color: #565656 !important;

  .v-toolbar__title {
    font-size: 18px;
    font-weight: 500;
  }
}
.header-button {
  background-color: #f9fafb !important;
  color: rgba($color: #000000, $alpha: 0.7) !important;
}

.v-navigation-drawer {
  background: rgb(34, 136, 204) !important;
  -webkit-box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.3);
  // background: linear-gradient(
  //   180deg,
  //   rgba(34, 136, 204, 1) 0%,
  //   rgba(47, 152, 222, 1) 40%,
  //   rgba(255, 255, 255, 1) 100%
  // );
}

footer {
  // background: rgb(34, 136, 204) !important;
  background: rgb(36, 119, 175) !important;
}
</style>
